export default __webpack_public_path__ + "static/media/bmw.fed22ea2.png";